<template>
  <div class="gr-root">
    <div class="gr-card">
      <div class="gr-card-header">
        <div class="gr-card-header-left">
          <div class="gr-card-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ff825d"
              stroke-width="2"
            >
              <path d="M3 2h18v4H3zM3 10h18v12H3z" />
              <path d="M8 14h8M8 18h5" />
            </svg>
          </div>
          <div>
            <h2 class="gr-title">Os teus restaurantes</h2>
            <p class="gr-sub">
              Gere, edita e adiciona restaurantes ao teu negócio
            </p>
          </div>
        </div>
        <button class="gr-btn-add" @click="abrirModal()">
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path d="M12 5v14M5 12h14" />
          </svg>
          Adicionar restaurante
        </button>
      </div>

      <!-- LOADING -->
      <div v-if="loading" class="gr-loading">
        <span class="gr-loading-spinner"></span>
        A carregar restaurantes…
      </div>

      <!-- EMPTY -->
      <div v-else-if="!restaurantes.length" class="gr-empty">
        <div class="gr-empty-icon">🍽️</div>
        <h3>Nenhum restaurante ainda</h3>
        <p>Adiciona o teu primeiro restaurante para começar a usar o Abitué.</p>
        <button class="gr-btn-add" @click="abrirModal()">
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path d="M12 5v14M5 12h14" />
          </svg>
          Adicionar restaurante
        </button>
      </div>

      <!-- LISTA -->
      <div v-else class="gr-list">
        <div v-for="r in restaurantes" :key="r.id" class="gr-item">
          <div class="gr-item-avatar">
            {{ (r.nome || "?")[0].toUpperCase() }}
          </div>
          <div class="gr-item-info">
            <span class="gr-item-nome">{{ r.nome }}</span>
            <span class="gr-item-contact">{{
              r.email || r.telefone || r.morada || "—"
            }}</span>
          </div>
          <div class="gr-item-middle">
            <span
              class="gr-item-badge"
              :class="integracaoOk(r) ? 'badge-ok' : 'badge-warn'"
            >
              {{ integracaoOk(r) ? "✓ POS integrado" : "⚠ Sem integração POS" }}
            </span>
          </div>
          <div class="gr-item-actions">
            <button class="gr-btn-edit" @click="abrirModal(r)">
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                />
                <path
                  d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                />
              </svg>
              Editar
            </button>
            <button
              class="gr-btn-del"
              @click="confirmarRemoverItem = r"
              title="Remover"
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                <path d="M10 11v6M14 11v6" />
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════════════════
         MODAL ADICIONAR / EDITAR
    ══════════════════════════════════════════ -->
    <transition name="gr-fade">
      <div v-if="modalAberto" class="gr-overlay" @click.self="fecharModal">
        <div class="gr-modal">
          <!-- Cabeçalho do modal -->
          <div class="gr-modal-head">
            <div class="gr-modal-head-left">
              <div class="gr-modal-icon">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#ff825d"
                  stroke-width="2"
                >
                  <path d="M3 2h18v4H3zM3 10h18v12H3z" />
                  <path d="M8 14h8M8 18h5" />
                </svg>
              </div>
              <div>
                <h3 class="gr-modal-title">
                  {{ editando ? "Editar restaurante" : "Novo restaurante" }}
                </h3>
                <p class="gr-modal-sub">
                  {{
                    editando
                      ? "Actualiza os dados e a integração"
                      : "Preenche os dados e testa a ligação POS"
                  }}
                </p>
              </div>
            </div>
            <button class="gr-modal-close" @click="fecharModal">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
              >
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          </div>

          <!-- Corpo do modal — 2 colunas -->
          <div class="gr-modal-body">
            <!-- COLUNA ESQUERDA -->
            <div class="gr-modal-col">
              <div class="gr-section-label">Informações do restaurante</div>

              <div class="gr-field gr-field-full">
                <label>Nome *</label>
                <input
                  v-model="form.nome"
                  class="gr-inp"
                  :class="{ err: erros.nome }"
                  placeholder="Ex: Restaurante Central"
                  @input="erros.nome = ''"
                />
                <p v-if="erros.nome" class="gr-err">{{ erros.nome }}</p>
              </div>

              <div class="gr-row">
                <div class="gr-field">
                  <label>Email</label>
                  <input
                    v-model="form.email"
                    class="gr-inp"
                    type="email"
                    placeholder="geral@restaurante.pt"
                  />
                </div>
                <div class="gr-field">
                  <label>Telefone</label>
                  <input
                    v-model="form.telefone"
                    class="gr-inp"
                    placeholder="912 345 678"
                  />
                </div>
              </div>

              <div class="gr-field gr-field-full">
                <label>Morada</label>
                <input
                  v-model="form.morada"
                  class="gr-inp"
                  placeholder="Rua..., Nº, Cidade"
                />
              </div>

              <!-- Integração POS — obrigatória -->
              <div class="gr-section-label gr-section-label--mt">
                Integração {{ posLabel }}
                <span class="gr-required-badge">obrigatório</span>
              </div>

              <div class="gr-row">
                <div class="gr-field">
                  <label>App Key</label>
                  <input
                    v-model="form.app_key"
                    class="gr-inp gr-inp-mono"
                    :class="{ err: erros.integracao && !form.app_key }"
                    placeholder="app_key_..."
                    @input="resetTeste"
                  />
                </div>
                <div class="gr-field">
                  <label>App Secret</label>
                  <input
                    v-model="form.app_secret"
                    class="gr-inp gr-inp-mono"
                    :class="{ err: erros.integracao && !form.app_secret }"
                    type="password"
                    placeholder="••••••••••"
                    @input="resetTeste"
                  />
                </div>
              </div>

              <div class="gr-field">
                <label>Client ID</label>
                <input
                  v-model="form.client_id"
                  class="gr-inp gr-inp-mono"
                  :class="{ err: erros.integracao && !form.client_id }"
                  placeholder="client_..."
                  @input="resetTeste"
                />
              </div>

              <!-- Secção Meta / WhatsApp -->
              <div class="gr-section-label gr-section-label--mt">
                Meta / WhatsApp
                <span class="gr-opt-badge">opcional</span>
              </div>
              <div class="gr-field">
                <label>Nome do template</label>
                <input
                  v-model="form.template_whatsapp"
                  class="gr-inp"
                  placeholder="ex: boas_vindas"
                />
                <p class="gr-field-hint">
                  Template de WhatsApp enviado ao criar um novo cartão de
                  cliente.
                </p>
              </div>

              <!-- Botão testar ligação -->
              <div class="gr-test-wrap">
                <button
                  class="gr-btn-test"
                  :class="{ ok: testeOk === true, fail: testeOk === false }"
                  :disabled="
                    !form.app_key ||
                    !form.app_secret ||
                    !form.client_id ||
                    testandoLigacao
                  "
                  @click="testarLigacao"
                >
                  <span v-if="testandoLigacao" class="gr-spinner-sm"></span>
                  <svg
                    v-else-if="testeOk === true"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <svg
                    v-else-if="testeOk === false"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                  >
                    <path d="M18 6 6 18M6 6l12 12" />
                  </svg>
                  <svg
                    v-else
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                  </svg>
                  {{
                    testandoLigacao
                      ? "A testar..."
                      : testeOk === true
                      ? "Ligação OK!"
                      : testeOk === false
                      ? "Falhou — tentar novamente"
                      : "Testar ligação"
                  }}
                </button>
                <p
                  v-if="testeMensagem"
                  class="gr-test-msg"
                  :class="{ ok: testeOk === true, fail: testeOk === false }"
                >
                  {{ testeMensagem }}
                </p>
                <p v-if="erros.integracao" class="gr-err">
                  {{ erros.integracao }}
                </p>
              </div>
            </div>

            <!-- COLUNA DIREITA — estado / dicas -->
            <div class="gr-modal-sidebar">
              <div class="gr-sidebar-card">
                <p class="gr-sidebar-title">Estado da integração</p>
                <div
                  class="gr-status-indicator"
                  :class="{
                    ok: testeOk === true,
                    fail: testeOk === false,
                    idle: testeOk === null,
                  }"
                >
                  <div class="gr-status-dot"></div>
                  <span>{{
                    testeOk === true
                      ? "Ligação verificada"
                      : testeOk === false
                      ? "Erro na ligação"
                      : "Por verificar"
                  }}</span>
                </div>
                <p class="gr-sidebar-tip">
                  {{
                    testeOk === true
                      ? "As credenciais são válidas. Podes guardar o restaurante."
                      : testeOk === false
                      ? "Verifica as credenciais na plataforma Zonesoft."
                      : 'Preenche as credenciais e clica em "Testar ligação" para verificar.'
                  }}
                </p>
              </div>

              <div class="gr-sidebar-tip-card">
                <p class="gr-sidebar-tip-title">
                  💡 Onde encontrar as credenciais?
                </p>
                <p class="gr-sidebar-tip-txt">
                  Acede ao backoffice da Zonesoft → Definições → API → Gestão de
                  Apps e copia o App Key, App Secret e Client ID.
                </p>
              </div>
            </div>
          </div>

          <!-- Rodapé do modal -->
          <div class="gr-modal-foot">
            <button class="gr-btn-ghost" @click="fecharModal">Cancelar</button>
            <button class="gr-btn-primary" :disabled="saving" @click="guardar">
              <span v-if="saving" class="gr-spinner-sm"></span>
              <span v-else>{{
                editando ? "Guardar alterações" : "Adicionar restaurante"
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- CONFIRM REMOVE -->
    <transition name="gr-fade">
      <div
        v-if="confirmarRemoverItem"
        class="gr-overlay"
        @click.self="confirmarRemoverItem = null"
      >
        <div class="gr-modal gr-modal-sm">
          <div class="gr-modal-head">
            <h3 class="gr-modal-title">Remover restaurante</h3>
            <button class="gr-modal-close" @click="confirmarRemoverItem = null">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
              >
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div class="gr-modal-body gr-modal-body-sm">
            <div class="gr-remove-icon">⚠️</div>
            <p class="gr-remove-msg">
              Tens a certeza que queres remover
              <strong>{{ confirmarRemoverItem.nome }}</strong
              >?<br />Esta acção não pode ser desfeita.
            </p>
          </div>
          <div class="gr-modal-foot">
            <button class="gr-btn-ghost" @click="confirmarRemoverItem = null">
              Cancelar
            </button>
            <button class="gr-btn-danger" :disabled="saving" @click="remover">
              <span v-if="saving" class="gr-spinner-sm"></span>
              <span v-else>Remover</span>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import api from "@/api";

  const emptyForm = () => ({
    nome: "",
    email: "",
    telefone: "",
    morada: "",
    app_key: "",
    app_secret: "",
    client_id: "",
    template_whatsapp: "",
  });

  export default {
    name: "GerirRestaurantes",
    data() {
      return {
        loading: true,
        saving: false,
        restaurantes: [],
        modalAberto: false,
        editando: null,
        form: emptyForm(),
        erros: { nome: "", integracao: "" },
        confirmarRemoverItem: null,
        // Test connection
        testandoLigacao: false,
        testeOk: null,
        testeMensagem: "",
        pos: "zonesoft",
      };
    },

    computed: {
      posLabel() {
        return (
          { zonesoft: "Zonesoft", winrest: "Winrest", custom: "POS" }[
            this.pos
          ] || "Zonesoft"
        );
      },
    },

    methods: {
      integracaoOk(r) {
        return !!(r.app_key && r.app_secret && r.client_id);
      },

      resetTeste() {
        this.testeOk = null;
        this.testeMensagem = "";
        this.erros.integracao = "";
      },

      async testarLigacao() {
        this.testandoLigacao = true;
        this.testeOk = null;
        this.testeMensagem = "";
        try {
          const { data } = await api.post("/restaurantes/test-connection", {
            app_key: this.form.app_key,
            app_secret: this.form.app_secret,
            client_id: this.form.client_id,
          });
          this.testeOk = data.success;
          this.testeMensagem = data.message;
        } catch (err) {
          this.testeOk = false;
          this.testeMensagem =
            err.response?.data?.message || "Erro ao testar ligação.";
        } finally {
          this.testandoLigacao = false;
        }
      },

      async carregar() {
        this.loading = true;
        try {
          const { data } = await api.get("/restaurantes");
          this.restaurantes = Array.isArray(data)
            ? data
            : data.restaurantes || [];
        } catch {
          this.$notify({
            type: "danger",
            title: "Erro",
            message: "Não foi possível carregar os restaurantes.",
          });
        } finally {
          this.loading = false;
        }
      },

      abrirModal(r = null) {
        this.erros = { nome: "", integracao: "" };
        this.testeOk = null;
        this.testeMensagem = "";
        if (r) {
          this.editando = r.id;
          this.form = {
            nome: r.nome || "",
            email: r.email || "",
            telefone: r.telefone || "",
            morada: r.morada || "",
            app_key: r.app_key || "",
            app_secret: r.app_secret || "",
            client_id: r.client_id || "",
            template_whatsapp: r.template_whatsapp || "",
          };
          // Se já tem integração, marcar como verificada
          if (this.integracaoOk(r)) {
            this.testeOk = true;
            this.testeMensagem = "Integração já configurada.";
          }
        } else {
          this.editando = null;
          this.form = emptyForm();
        }
        this.modalAberto = true;
      },

      fecharModal() {
        this.modalAberto = false;
      },

      async guardar() {
        this.erros = { nome: "", integracao: "" };
        if (!this.form.nome.trim()) {
          this.erros.nome = "Nome é obrigatório.";
          return;
        }
        if (
          !this.form.app_key ||
          !this.form.app_secret ||
          !this.form.client_id
        ) {
          this.erros.integracao =
            "Preenche todas as credenciais de integração.";
          return;
        }
        if (this.testeOk !== true) {
          this.erros.integracao =
            "Testa a ligação à Zonesoft antes de guardar.";
          return;
        }

        this.saving = true;
        try {
          if (this.editando) {
            await api.put(`/restaurantes/${this.editando}`, this.form);
            this.$notify({
              type: "success",
              title: "Guardado",
              message: "Restaurante atualizado com sucesso.",
            });
          } else {
            await api.post("/restaurantes", this.form);
            this.$router._setupChecked = true;
            this.$router._temRestaurantes = true;
            this.$notify({
              type: "success",
              title: "Adicionado",
              message: "Restaurante criado com sucesso.",
            });
          }
          this.fecharModal();
          await this.carregar();
        } catch (err) {
          this.$notify({
            type: "danger",
            title: "Erro",
            message: err.response?.data?.error || "Erro ao guardar.",
          });
        } finally {
          this.saving = false;
        }
      },

      async remover() {
        this.saving = true;
        try {
          await api.delete(`/restaurantes/${this.confirmarRemoverItem.id}`);
          this.confirmarRemoverItem = null;
          this.$notify({
            type: "success",
            title: "Removido",
            message: "Restaurante removido com sucesso.",
          });
          await this.carregar();
        } catch (err) {
          this.$notify({
            type: "danger",
            title: "Erro",
            message: err.response?.data?.error || "Erro ao remover.",
          });
        } finally {
          this.saving = false;
        }
      },
    },

    mounted() {
      // Ler POS do utilizador guardado no localStorage
      try {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        this.pos = user.pos || localStorage.getItem("abitue_pos") || "zonesoft";
      } catch {
        this.pos = "zonesoft";
      }
      this.carregar();
    },
  };
</script>

<style scoped lang="scss">
  $orange: #ff825d;
  $dark: #1a1210;

  .gr-root {
    font-family: "DM Sans", "Outfit", system-ui, sans-serif;
    padding: 28px 28px 48px;
    min-height: 100vh;
    background: #f8f6f3;
  }

  /* ── CARD PRINCIPAL ── */
  .gr-card {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    overflow: hidden;
  }
  .gr-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 28px;
    border-bottom: 1px solid #f5f2ef;
    flex-wrap: wrap;
    gap: 14px;
  }
  .gr-card-header-left {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .gr-card-icon {
    width: 44px;
    height: 44px;
    background: #fff5f0;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .gr-title {
    font-size: 18px;
    font-weight: 800;
    color: $dark;
    margin: 0;
  }
  .gr-sub {
    font-size: 13px;
    color: #b0a8a0;
    margin: 3px 0 0;
  }

  /* Loading */
  .gr-loading {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 48px;
    justify-content: center;
    color: #b0a8a0;
    font-size: 14px;
  }
  .gr-loading-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid #f0ece8;
    border-top-color: $orange;
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
  }

  /* Empty */
  .gr-empty {
    text-align: center;
    padding: 64px 24px;
  }
  .gr-empty-icon {
    font-size: 52px;
    margin-bottom: 16px;
  }
  .gr-empty h3 {
    font-size: 18px;
    font-weight: 700;
    color: #5a534f;
    margin-bottom: 8px;
  }
  .gr-empty p {
    font-size: 14px;
    color: #b0a8a0;
    margin-bottom: 24px;
  }

  /* Lista */
  .gr-list {
    padding: 8px 0;
  }
  .gr-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 28px;
    border-bottom: 1px solid #f8f5f2;
    transition: background 0.08s;
    &:last-child {
      border-bottom: none;
    }
    &:hover {
      background: #fdfcfb;
    }
  }
  .gr-item-avatar {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: $orange;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 700;
    flex-shrink: 0;
  }
  .gr-item-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 3px;
  }
  .gr-item-nome {
    font-size: 15px;
    font-weight: 700;
    color: $dark;
  }
  .gr-item-contact {
    font-size: 12.5px;
    color: #b0a8a0;
  }
  .gr-item-middle {
    flex-shrink: 0;
  }
  .gr-item-badge {
    font-size: 12px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 20px;
    &.badge-ok {
      background: #e8faf2;
      color: #0a7a4a;
    }
    &.badge-warn {
      background: #fff8e8;
      color: #c07800;
    }
  }
  .gr-item-actions {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
  }

  /* Botões */
  .gr-btn-add {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 11px 20px;
    border: none;
    border-radius: 11px;
    background: $orange;
    color: #fff;
    font-size: 13.5px;
    font-weight: 700;
    cursor: pointer;
    font-family: inherit;
    box-shadow: 0 3px 12px rgba(255, 130, 93, 0.3);
    transition: all 0.15s;
    &:hover {
      background: #e86b45;
      transform: translateY(-1px);
    }
  }
  .gr-btn-edit {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 14px;
    border: 1.5px solid #e8e4e0;
    border-radius: 8px;
    background: #fff;
    color: #5a534f;
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
    font-family: inherit;
    transition: all 0.12s;
    &:hover {
      border-color: $orange;
      color: $orange;
    }
  }
  .gr-btn-del {
    width: 34px;
    height: 34px;
    border: 1.5px solid #e8e4e0;
    border-radius: 8px;
    background: #fff;
    color: #b0a8a0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.12s;
    &:hover {
      border-color: #e53e3e;
      color: #e53e3e;
      background: #fff8f8;
    }
  }

  /* ── MODAL ── */
  .gr-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 10, 8, 0.45);
    backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1200;
    padding: 16px;
  }
  .gr-modal {
    background: #fff;
    border-radius: 20px;
    width: 100%;
    max-width: 860px;
    max-height: 92vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.22);
    overflow: hidden;
  }
  .gr-modal-sm {
    max-width: 400px;
  }

  .gr-modal-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 22px 28px 18px;
    border-bottom: 1px solid #f5f2ef;
    gap: 14px;
  }
  .gr-modal-head-left {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .gr-modal-icon {
    width: 40px;
    height: 40px;
    background: #fff5f0;
    border-radius: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .gr-modal-title {
    font-size: 17px;
    font-weight: 800;
    color: $dark;
    margin: 0;
  }
  .gr-modal-sub {
    font-size: 13px;
    color: #b0a8a0;
    margin: 3px 0 0;
  }
  .gr-modal-close {
    background: #f7f4f1;
    border: none;
    cursor: pointer;
    width: 32px;
    height: 32px;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7a736e;
    flex-shrink: 0;
    transition: all 0.12s;
    &:hover {
      background: #f0ece8;
      color: $dark;
    }
  }

  /* Modal body — 2 colunas */
  .gr-modal-body {
    display: grid;
    grid-template-columns: 1fr 240px;
    gap: 0;
    overflow-y: auto;
    flex: 1;
  }
  .gr-modal-body-sm {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 28px 24px;
    gap: 12px;
  }
  .gr-modal-col {
    padding: 24px 28px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    border-right: 1px solid #f5f2ef;
  }
  .gr-modal-sidebar {
    padding: 24px 20px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    background: #faf8f6;
  }

  /* Sidebar */
  .gr-sidebar-card {
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    border: 1.5px solid #f0ece8;
  }
  .gr-sidebar-title {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #b0a8a0;
    margin-bottom: 12px;
  }
  .gr-status-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border-radius: 9px;
    margin-bottom: 10px;
    font-size: 13px;
    font-weight: 600;
    &.idle {
      background: #f7f4f1;
      color: #7a736e;
      .gr-status-dot {
        background: #c8c0b8;
      }
    }
    &.ok {
      background: #e8faf2;
      color: #0a7a4a;
      .gr-status-dot {
        background: #0a7a4a;
      }
    }
    &.fail {
      background: #fff8f8;
      color: #e53e3e;
      .gr-status-dot {
        background: #e53e3e;
      }
    }
  }
  .gr-status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }
  .gr-sidebar-tip {
    font-size: 12.5px;
    color: #7a736e;
    line-height: 1.5;
    margin: 0;
  }
  .gr-sidebar-tip-card {
    background: rgba(255, 130, 93, 0.06);
    border: 1.5px solid rgba(255, 130, 93, 0.15);
    border-radius: 12px;
    padding: 14px 16px;
  }
  .gr-sidebar-tip-title {
    font-size: 12.5px;
    font-weight: 700;
    color: $orange;
    margin-bottom: 6px;
  }
  .gr-sidebar-tip-txt {
    font-size: 12px;
    color: #7a736e;
    line-height: 1.55;
    margin: 0;
  }

  /* Campos */
  .gr-section-label {
    font-size: 10.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #b0a8a0;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .gr-section-label--mt {
    margin-top: 4px;
  }
  .gr-required-badge {
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    background: #fff0eb;
    color: $orange;
    padding: 2px 8px;
    border-radius: 20px;
  }
  .gr-field {
    display: flex;
    flex-direction: column;
    gap: 5px;
    label {
      font-size: 12px;
      font-weight: 700;
      color: #7a736e;
    }
  }
  .gr-field-full {
  }
  .gr-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
  .gr-inp {
    height: 46px;
    border: 1.5px solid #e8e4e0;
    border-radius: 11px;
    padding: 0 14px;
    font-size: 14px;
    color: $dark;
    outline: none;
    font-family: inherit;
    background: #fdfcfb;
    transition: all 0.15s;
    &:focus {
      border-color: $orange;
      background: #fff;
      box-shadow: 0 0 0 3px rgba(255, 130, 93, 0.1);
    }
    &.err {
      border-color: #e53e3e;
    }
    &::placeholder {
      color: #c8c0b8;
    }
  }
  .gr-inp-mono {
    font-family: monospace;
    font-size: 12.5px;
  }
  .gr-err {
    font-size: 12px;
    color: #e53e3e;
    margin-top: 2px;
  }

  /* Test button */
  .gr-test-wrap {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .gr-btn-test {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 18px;
    border: 1.5px solid #e8e4e0;
    border-radius: 10px;
    background: #fff;
    color: #5a534f;
    font-size: 13.5px;
    font-weight: 600;
    cursor: pointer;
    font-family: inherit;
    transition: all 0.15s;
    align-self: flex-start;
    &:hover:not(:disabled) {
      border-color: $orange;
      color: $orange;
    }
    &:disabled {
      opacity: 0.45;
      cursor: default;
    }
    &.ok {
      border-color: #0a7a4a;
      background: #e8faf2;
      color: #0a7a4a;
    }
    &.fail {
      border-color: #e53e3e;
      background: #fff8f8;
      color: #e53e3e;
    }
  }
  .gr-test-msg {
    font-size: 12.5px;
    font-weight: 500;
    margin: 0;
    &.ok {
      color: #0a7a4a;
    }
    &.fail {
      color: #e53e3e;
    }
  }

  /* Rodapé */
  .gr-modal-foot {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    padding: 18px 28px;
    border-top: 1px solid #f5f2ef;
    flex-shrink: 0;
  }
  .gr-btn-ghost {
    display: inline-flex;
    align-items: center;
    padding: 11px 20px;
    border: 1.5px solid #e8e4e0;
    border-radius: 11px;
    background: #fff;
    color: #7a736e;
    font-size: 13.5px;
    font-weight: 600;
    cursor: pointer;
    font-family: inherit;
    &:hover {
      background: #f7f4f1;
    }
  }
  .gr-btn-primary {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 11px 22px;
    border: none;
    border-radius: 11px;
    background: $orange;
    color: #fff;
    font-size: 13.5px;
    font-weight: 700;
    cursor: pointer;
    font-family: inherit;
    box-shadow: 0 3px 12px rgba(255, 130, 93, 0.3);
    transition: all 0.15s;
    &:hover:not(:disabled) {
      background: #e86b45;
    }
    &:disabled {
      opacity: 0.5;
      cursor: default;
      box-shadow: none;
    }
  }
  .gr-btn-danger {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 11px 22px;
    border: none;
    border-radius: 11px;
    background: #e53e3e;
    color: #fff;
    font-size: 13.5px;
    font-weight: 700;
    cursor: pointer;
    font-family: inherit;
    &:hover:not(:disabled) {
      background: #c53030;
    }
    &:disabled {
      opacity: 0.5;
      cursor: default;
    }
  }

  /* Remove modal */
  .gr-remove-icon {
    font-size: 40px;
  }
  .gr-remove-msg {
    font-size: 14px;
    color: #5a534f;
    text-align: center;
    line-height: 1.6;
    margin: 0;
  }

  /* Spinner */
  .gr-spinner-sm {
    width: 15px;
    height: 15px;
    border: 2px solid rgba(255, 255, 255, 0.4);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  /* Fade */
  .gr-fade-enter-active {
    transition: opacity 0.2s;
  }
  .gr-fade-leave-active {
    transition: opacity 0.15s;
  }
  .gr-fade-enter,
  .gr-fade-leave-to {
    opacity: 0;
  }

  @media (max-width: 700px) {
    .gr-modal-body {
      grid-template-columns: 1fr;
    }
    .gr-modal-sidebar {
      border-top: 1px solid #f5f2ef;
    }
    .gr-modal-col {
      border-right: none;
    }
  }

  .gr-opt-badge {
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    background: #e8e4e0;
    color: #7a736e;
    padding: 2px 8px;
    border-radius: 20px;
  }
  .gr-field-hint {
    font-size: 11.5px;
    color: #b0a8a0;
    margin-top: 4px;
  }
</style>
